/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderDailyStatsItemSchema = z.object({
	date: z.iso.date(),
	count: z.int(),
});
